'use client'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const SPGMI_RED = '#D70025'

// Sizes are proportional to the viewport to match S&P's banner artwork
export const AnnouncementBackground = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  background: 'radial-gradient(ellipse at 45% 110%, rgba(215, 0, 37, 0.2), transparent 50%), #000',
  color: theme.palette.common.white,
}))

export const AnnouncementGlobe = styled(Box)(({ theme }) => ({
  display: 'none',
  position: 'absolute',
  top: 0,
  right: 0,
  height: '100%',
  maskImage: 'linear-gradient(to right, transparent, #000 30%)',

  img: {
    height: '100%',
    width: 'auto',
  },

  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
}))

export const LearnMoreButton = styled(Button)(({ theme }) => ({
  marginTop: 'clamp(20px, 2.4vw, 36px)',
  backgroundColor: SPGMI_RED,
  color: theme.palette.common.white,
  borderRadius: '100px',
  padding: '0.55em 1.6em',
  fontSize: 'clamp(16px, 1.8vw, 26px)',
  fontWeight: 700,
  lineHeight: 1.2,
  textTransform: 'none',
  boxShadow: '0 0 20px rgba(215, 0, 37, 0.6)',

  '&:hover': {
    backgroundColor: '#B00022',
  },

  '.MuiButton-endIcon > svg': {
    fontSize: '1.3em',
  },
})) as typeof Button // Keep the href/target overload

export default {}
